import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { LoadScript } from '@react-google-maps/api';

import { history } from '../../helpers';
import Calendar from '../../pages/calendar/calendar.component';
import Dashboard from '../../pages/dashboard/dashboard.component';
import LogIn from '../../pages/login/login.component';
import UserList from '../../pages/admin-user/user-list.component';
import UserAddOrEdit from '../../pages/admin-user/user-add-or-edit.component';
import FormEdit from '../../pages/admin-form/form-edit.component';
import Map from '../../pages/map/map.component';
import MyDay from '../../pages/my-day/my-day.component';
import NotFound from '../../pages/not-found/not-found.component';
import ProjectActive from '../../pages/project-active/project-active.component';
import ProjectAddOrEdit from '../../pages/project-add-or-edit/project-add-or-edit.component';
import ProjectArchive from '../../pages/project-archive/project-archive.component';
import ProjectLog from '../../pages/project-log/project-log.component';
import TestPdf from '../../pages/test/testpdf';
import { selectCurrentUser } from '../../redux/user/user.selectors';
import Header from '../header/header.component';

const libraries = ['places', 'geometry', 'drawing'];

class ProjectRoutes extends React.Component {
	state = {
        scriptLoaded: false,
        scriptError: null
    };

    handleScriptLoad = () => {
        this.setState({ scriptLoaded: true });
    };

    handleScriptError = (error) => {
        console.error('Google Maps Script Error:', error);
        this.setState({ scriptError: error });
    };

	render() {
		const { currentUser } = this.props;
		return (
			<div className='dashboard-container-wrapper'>
				<Router history={history}>
					<Header />
					<LoadScript
                        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                        libraries={libraries}
                        language="no"
                        region="NO"
                        onLoad={this.handleScriptLoad}
                        onError={this.handleScriptError}
                        loadingElement={<div>Loading Google Maps...</div>}
                    >
						<Switch>
							<Route path='/' exact component={Dashboard} />
							<Route path='/login' render={() => (currentUser ? <Redirect to='/' /> : <LogIn />)} />
							<Route path='/project-add' exact component={ProjectAddOrEdit} />
							<Route path='/project-active' exact component={ProjectActive} />
							<Route path='/project-active/:projectId' component={ProjectAddOrEdit} />
							<Route path='/project-archive' exact component={ProjectArchive} />
							<Route path='/project-archive/:projectId' component={ProjectAddOrEdit} />
							<Route path='/project-log' exact component={ProjectLog} />
							<Route path='/my-day' exact component={MyDay} />
							<Route path='/calendar' exact component={Calendar} />
							<Route path='/map' exact component={Map} />
							<Route path='/admin-user' exact component={UserList} />
							<Route path='/admin-user/:userId' component={UserAddOrEdit} />
							<Route path='/admin-form' exact component={FormEdit} />
							<Route path='/test' exact component={TestPdf} />
							<Route component={NotFound} />
						</Switch>
					</LoadScript>
				</Router>
			</div>
		);
	}
}

const mapStateToProps = createStructuredSelector({
	currentUser: selectCurrentUser
});

export default connect(mapStateToProps)(ProjectRoutes);
